export default __webpack_public_path__ + "static/media/location.861a8c40.svg";